/* LOGGD redesign: one-click add for upsells (product page "pairs well with" + cart drawer) */
(function () {
  if (window.__lgAddBound) return;
  window.__lgAddBound = true;

  function addVariant(id, btn) {
    var drawer = document.querySelector('cart-drawer');
    var notification = document.querySelector('cart-notification');
    var target = drawer || notification;
    var body = { items: [{ id: parseInt(id, 10), quantity: 1 }] };
    if (target && typeof target.getSectionsToRender === 'function') {
      body.sections = target.getSectionsToRender().map(function (s) { return s.id; });
      body.sections_url = window.location.pathname;
    }
    var old = btn ? btn.textContent : '';
    if (btn) { btn.disabled = true; btn.textContent = '...'; }
    return fetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json(); }).then(function (res) {
      if (res.status) { alert(res.description || 'Could not add this item.'); return; }
      if (target && typeof target.renderContents === 'function') {
        target.renderContents(res);
      } else {
        window.location.href = '/cart';
      }
    }).catch(function () { window.location.href = '/cart'; })
      .finally(function () { if (btn) { btn.disabled = false; btn.textContent = old; } });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-lg-add]');
    if (!btn) return;
    e.preventDefault();
    addVariant(btn.getAttribute('data-lg-add'), btn);
  });
})();

/* auto-apply the offer discount code to the checkout session (once per browser session) */
(function () {
  var code = window.lgOfferCode;
  if (!code) return;
  try { if (sessionStorage.getItem('lgOfferApplied') === code) return; } catch (e) {}
  fetch('/discount/' + encodeURIComponent(code) + '?redirect=/', { credentials: 'same-origin' })
    .then(function () { try { sessionStorage.setItem('lgOfferApplied', code); } catch (e) {} })
    .catch(function () {});
})();

/* prev / next arrows for [data-lg-scroller] on mobile */
(function () {
  function setup(wrap) {
    var track = wrap.querySelector('[data-lg-scroller]');
    var prev = wrap.querySelector('[data-lg-prev]');
    var next = wrap.querySelector('[data-lg-next]');
    var count = wrap.querySelector('[data-lg-count]');
    if (!track || !prev || !next) return;
    function cards() { return Array.prototype.filter.call(track.children, function (c) { return !c.classList.contains('is-hidden'); }); }
    function index() {
      var cs = cards(); if (!cs.length) return 0;
      var w = cs[0].getBoundingClientRect().width || 1;
      return Math.max(0, Math.min(cs.length - 1, Math.round(track.scrollLeft / w)));
    }
    function update() {
      var cs = cards(); var i = index();
      if (count) count.textContent = (i + 1) + ' / ' + cs.length;
      prev.disabled = i <= 0; next.disabled = i >= cs.length - 1;
    }
    function go(delta) {
      var cs = cards(); if (!cs.length) return;
      var i = Math.max(0, Math.min(cs.length - 1, index() + delta));
      track.scrollTo({ left: cs[i].offsetLeft - track.offsetLeft, behavior: 'smooth' });
      setTimeout(update, 400);
    }
    prev.addEventListener('click', function () { go(-1); });
    next.addEventListener('click', function () { go(1); });
    track.addEventListener('scroll', function () { window.clearTimeout(track._lgT); track._lgT = setTimeout(update, 120); });
    update();
  }
  function init() { document.querySelectorAll('.lg-scroller-wrap').forEach(setup); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
